import React from 'react'

import _ from 'lodash'
import { Header, List, Segment } from 'semantic-ui-react'

import { ITheme } from '../../../api/Data'
import DesignerTabSection from '../../designer/DesignerTabSection'
import CustomLabel from '../../../components/common/custom-label/CustomLabel'

const CustomizeVideoTemplatePage = ({ theme, handleChangeTheme }: IProps) => {
  console.log('Rendering Video Layout Page', theme)

  return (
    <>
      <Header as="h1" style={{ marginBottom: '2rem', fontWeight: 'bold' }}>
        Video Template Builder
        <Header.Subheader>
          <p>Add attribution, branding, and dynamic overlays to every contributor video—automatically.</p>
          <p>
            Design once, and apply consistently. The Vloggi Video Template Builder allows you to create visual effects
            templates that are automatically applied to all video submissions. Pull in any data collected—such as name,
            store number, or timestamp—and display it as dynamic on-screen elements like lower-thirds, watermarks, and
            more.
          </p>
        </Header.Subheader>
      </Header>

      <Segment>
        <Header as="h2">
          Build Your Template Visually
          <CustomLabel>
            <CustomLabel.Popup popupContent="Think of this as a smart “lower-thirds” engine—with the ability to change per contributor, per video, all without editing anything manually." />
          </CustomLabel>
        </Header>
        <p>
          You can add and position elements on your video preview using the drag-and-drop builder. Available components
          include:
        </p>
        <List as="ul">
          <List.Item as="li">Watermark - Add your logo or brand mark in a fixed position</List.Item>
          <List.Item as="li">Static text - Always the same text, e.g. “Official Submission”</List.Item>
          <List.Item as="li">Dynamic text - Pulls live data from your contributor fields (e.g. Name, Store)</List.Item>
          <List.Item as="li">Image - Insert campaign logos, icons, or bars to create visual graphics</List.Item>
          <List.Item as="li">Rating - Display ratings collected from contributors as stars</List.Item>
        </List>
        <p>Each element can be timed to appear, fade in/out, and layer exactly as you want.</p>

        <DesignerTabSection
          theme={_.cloneDeep(theme)}
          sectionName="vloggi"
          section={_.cloneDeep(theme.data.vloggi)}
          defaultFonts={theme.data.playlist.defaultFonts}
          updateTheme={handleChangeTheme}
        />

        <p style={{ marginTop: '1rem' }}>Use this tool to:</p>
        <List as="ul">
          <List.Item as="li">Add attribution to your contributors (e.g. Name, Location, Organisation)</List.Item>
          <List.Item as="li">Create evidence overlays (e.g. Time of recording, User ID)</List.Item>
          <List.Item as="li">Style your brand with your fonts, colours, and logo</List.Item>
          <List.Item as="li">Control appearance and timing (e.g. fade in/out, entry points, layering)</List.Item>
          <List.Item as="li">Add watermarks, graphics, ratings, and smart text</List.Item>
        </List>
      </Segment>
    </>
  )
}

interface IProps {
  theme: ITheme
  handleChangeTheme: (arg: ITheme) => void
}

export default CustomizeVideoTemplatePage
